import Link from "next/link";
import { Container } from "./container";

const footerLinks = [
  { href: "/boutique", label: "Boutique" },
  { href: "/qui-suis-je", label: "Qui suis-je" },
  { href: "/sources-d-inspiration", label: "Inspiration" },
  { href: "/travail-de-teinturiere", label: "Teinture" },
  { href: "/specificites-des-produits", label: "Spécificités" },
  { href: "/conseils-d-entretien", label: "Conseils d’entretien" },
  { href: "/contact", label: "Contact" },
];

export function SiteFooter() {
  return (
    <footer className="mt-8 border-t border-[var(--border)] bg-[#f4d7e7]">
      <Container className="grid gap-10 py-12 md:grid-cols-[1.2fr_0.8fr]">
        <div className="max-w-xl">
          <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--accent)]/75">
            Jour J Création
          </p>
          <h2 className="mt-3 text-3xl leading-tight sm:text-4xl">
            Une boutique pensée comme un univers chaleureux, artistique et sensible.
          </h2>
          <p className="mt-4 text-sm leading-7 text-[var(--foreground)]/72 sm:text-base">
            Je propose des kits de laines teintes à la main, composés avec soin,
            dans une approche à la fois artisanale, originale et profondément humaine.
          </p>
        </div>

        <div className="grid gap-8 sm:grid-cols-2">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--foreground)]/55">
              Navigation
            </p>
            <div className="mt-4 flex flex-col gap-3 text-sm text-[var(--foreground)]/75">
              {footerLinks.map((link) => (
                <Link
                  key={link.href}
                  href={link.href}
                  className="transition hover:text-[var(--primary)]"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--foreground)]/55">
              Esprit
            </p>
            <div className="mt-4 space-y-3 text-sm leading-6 text-[var(--foreground)]/72">
              <p>Teint à la main</p>
              <p>Couleurs chaudes et vibrantes</p>
              <p>Univers sobre, artistique et original</p>
            </div>
          </div>
        </div>
      </Container>

      <div className="border-t border-[var(--border)]/80">
        <Container className="flex flex-col gap-3 py-5 text-xs text-[var(--foreground)]/55 sm:flex-row sm:items-center sm:justify-between">
          <p>© Jour J Création — Tous droits réservés.</p>
          <p className="font-mono uppercase tracking-[0.16em]">
            Teintes • Matière • Création
          </p>
        </Container>
      </div>
    </footer>
  );
}